var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.5,298.9c45.1,0,81.7-36.6,81.7-81.7c0-45.1-36.6-81.7-81.7-81.7s-81.7,36.6-81.7,81.7 C231.8,262.3,268.3,298.8,313.5,298.9z M313.5,152.3c35.8,0,64.8,29,64.8,64.8c0,35.8-29,64.8-64.8,64.8c-35.8,0-64.8-29-64.8-64.8 C248.7,181.4,277.7,152.4,313.5,152.3z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.3,293.9c36.7,0,66.5-29.8,66.5-66.5c0-36.7-29.8-66.5-66.5-66.5s-66.5,29.8-66.5,66.5 C417.8,264.1,447.5,293.9,484.3,293.9z M484.3,175.5c28.7,0,51.9,23.2,51.9,51.9c0,28.7-23.2,51.9-51.9,51.9 c-28.7,0-51.9-23.2-51.9-51.9C432.4,198.7,455.6,175.5,484.3,175.5z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.3,293.9c36.7,0,66.5-29.8,66.5-66.5c0-36.7-29.8-66.5-66.5-66.5s-66.5,29.8-66.5,66.5 C75.8,264.1,105.5,293.9,142.3,293.9z M142.3,175.5c28.7,0,51.9,23.2,51.9,51.9c0,28.7-23.2,51.9-51.9,51.9 c-28.7,0-51.9-23.2-51.9-51.9C90.4,198.7,113.6,175.5,142.3,175.5z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M484.5,318.3c-33.2,0-63.4,15.2-82.8,41.2c-23.9-22.3-55.5-34.7-88.3-34.5c-35.3,0-68.1,13.7-92.5,38.6 c-24.6,25.2-38.2,59.7-38.2,97c0,4.7,3.8,8.4,8.5,8.5h244.4c4.7,0,8.4-3.8,8.5-8.5c0-8.5-0.7-17.1-2.2-25.5h138.6 c4.7,0,8.4-3.8,8.5-8.5c0-29.8-10.8-57.3-30.5-77.4C539,329.3,512.3,318.1,484.5,318.3z M200,452.1c1.9-29.6,13.5-56.5,33.1-76.7 c21.3-21.4,50.2-33.5,80.4-33.5c30.2,0,59.1,12.1,80.4,33.5c0.9,0.9,1.9,1.9,2.8,3l0.2,0.2c17.9,19.7,28.4,45.4,30.2,73.5H200z  M437.9,418.1c-5-16.8-13.4-32.5-24.5-46c14.8-21.1,38.2-34.5,63.8-36.6c25.6-2.1,50.9,7.2,69,25.5c14.7,15.1,23.5,35.1,25.4,57.1 H437.9z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226,359.5c-19.4-26-49.6-41.2-82.8-41.2c-27.8-0.2-54.5,11-74,30.9c-19.7,20.1-30.5,47.6-30.5,77.4c0,4.7,3.8,8.4,8.5,8.5 h138.6 M56,418.1c1.9-22,10.7-42.1,25.4-57.1c18.1-18.3,43.4-27.7,69-25.5c25.7,2.1,49,15.5,63.8,36.6c-11.1,13.6-19.4,29.2-24.5,46 H56z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.33a482ec47eaaa5659c8e095a449ad58.svg";
export { ForwardRef as ReactComponent };